import * as React from 'react';

import IconBoxApp512 from './IconBoxApp512';

export const iconBoxApp512 = () => <IconBoxApp512 />;

export default {
    title: 'Icon/Logo/IconBoxApp512',
    component: IconBoxApp512,
    parameters: {
        notes: "`import IconBoxApp512 from 'box-ui-elements/es/icon/logo/IconBoxApp512';`",
    },
};
